module.exports = __webpack_public_path__ + "static/img/reimaging-onboarding-result02.6341b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/reimaging-onboarding-result02.png
// module id = b8UC
// module chunks = 1